// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__ge6HU","title":"NotFound_title__-dnp3","message":"NotFound_message__ltNYJ"};